import { buildLayout } from '../build-layout';
import type { LandingLayout, LandingLayoutDefinition } from '../types';
import { chromeStyles } from './chrome.styles';
import { closingCtaStyles } from './closing-cta.styles';
import { contentStyles } from './content.styles';
import { faqStyles } from './faq.styles';
import { EDITORIAL_FONTS_HREF } from './fonts';
import { heroStyles } from './hero.styles';
import { plansStyles } from './plans.styles';
import { sharedStyles } from './shared.styles';
import { editorialTokens } from './tokens';

export const editorialDefinition: LandingLayoutDefinition = {
  id: 'editorial',
  tokens: editorialTokens,
  fontsHref: EDITORIAL_FONTS_HREF,
  styles: {
    shared: sharedStyles,
    chrome: chromeStyles,
    hero: heroStyles,
    content: contentStyles,
    plans: plansStyles,
    faq: faqStyles,
    closingCta: closingCtaStyles,
  },
};

/** Built once at module load; the unbranded page reuses this rather than rebuilding per render. */
export const editorialLayout: LandingLayout = buildLayout(editorialDefinition);
